import "./ElectricalContractors.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import TheContractorsProblem from "./sections/TheContractorsProblem";
import WhatContractorsOrder from "./sections/WhatContractorsOrder";
import TurnaroundHowItWorks from "./sections/TurnaroundHowItWorks";
import ComplianceForContractorWork from "./sections/ComplianceForContractorWork";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function ElectricalContractorsPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <TheContractorsProblem />
      <WhatContractorsOrder />
      <TurnaroundHowItWorks />
      <ComplianceForContractorWork />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}